import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { CheckCircle2, MessageCircle } from "lucide-react";
import { api } from "../lib/api";
import { waLink, bookingMessage } from "../lib/data";
import { useLang } from "../lib/i18n";
import { Btn, Pill } from "../components/dash/Shell";

export default function BookingStatus() {
  const { id } = useParams();
  const { state } = useLocation();
  const { lang, a } = useLang();
  const d = a.book;
  const [b, setB] = useState(state?.booking || null);

  useEffect(() => {
    api.get(`/bookings/${id}`).then(({ data }) => setB(data)).catch(() => {});
  }, [id]);

  if (!b) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-xs uppercase tracking-widest">Loading…</div>;

  const msg = bookingMessage(b);
  return (
    <div className="min-h-screen flex items-center justify-center px-5 arch-grid">
      <div data-testid="booking-success-card" className="w-full max-w-lg rounded-3xl border border-gold/30 bg-panel/80 backdrop-blur-xl p-8 sm:p-10 text-center">
        <CheckCircle2 size={48} className="text-mint mx-auto" />
        <h1 data-testid="booking-success-title" className="font-display font-extrabold text-3xl text-white mt-5">{d.success}</h1>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-6">{d.successSub}</p>
        <p data-testid="booking-id" className="font-mono text-2xl text-gold mt-1">{b.id}</p>
        <div className="mt-6 rounded-2xl border border-white/10 bg-ink/60 p-5 text-left text-sm space-y-2">
          <div className="flex justify-between text-slate-300"><span>{d.service}</span><span className="text-white">{b.service_name[lang]}</span></div>
          <div className="flex justify-between text-slate-300"><span>{d.date}</span><span className="text-white">{b.date} · {b.time}</span></div>
          {b.discount > 0 && <div className="flex justify-between text-mint"><span>{d.discount} ({b.coupon_code})</span><span>−₹{b.discount}</span></div>}
          <div className="flex justify-between text-white font-bold pt-2 border-t border-white/10"><span>{d.total}</span><span data-testid="booking-total">₹{b.total}</span></div>
          <div className="flex justify-between items-center pt-1"><span className="text-slate-300">{d.pay}</span><Pill tone={b.payment_status === "paid" ? "mint" : "gold"} testid="booking-payment-status">{b.payment_status}</Pill></div>
        </div>
        <p className="text-slate-400 text-sm mt-5">{d.successNote}</p>
        <div className="flex flex-col sm:flex-row gap-3 mt-7">
          <a data-testid="booking-whatsapp-share" href={waLink(msg)} target="_blank" rel="noreferrer" className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-gold text-ink font-semibold px-5 py-3 text-sm hover:bg-white"><MessageCircle size={15} /> {d.whatsapp}</a>
          <Link to="/" className="flex-1"><Btn variant="ghost" className="w-full py-3" data-testid="booking-back-home">{d.backHome}</Btn></Link>
        </div>
      </div>
    </div>
  );
}
